import classnames from 'classnames/bind'
import { FC } from 'react'
import { GlobalTextPreset } from '~/@types/text-preset'

import Cell from '~/components/Panels/SizeGuidePanel/Cell'

import { useStyle } from '~/providers/StyleProvider'

import { SIZE_GUIDE_TYPE } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

interface RowProps {
  activeUnit: 'CM' | 'INCH'
  rowIndex: number
  title: string
  type: string
  values:
    | {
        cm?: (string | number)[]
        inch?: (string | number)[]
      }
    | (string | number)[]
}

const Row: FC<RowProps> = ({ activeUnit, rowIndex, title, type, values }) => {
  let displayedValues: (string | number)[]

  const titleStyle = useStyle({
    textPreset: GlobalTextPreset.Label11Haffer,
  })

  if (typeof values === 'object' && ('cm' in values || 'inch' in values)) {
    displayedValues = activeUnit === 'CM' ? values.cm || [] : values.inch || []
  } else {
    displayedValues = values as (string | number)[]
  }

  return (
    <tr className={css.row}>
      <th className={cx(css.rowTitle, titleStyle)}>{title}</th>
      {displayedValues.map((value, cellIndex) => (
        <Cell
          key={cellIndex}
          bold={rowIndex === 0 && type !== SIZE_GUIDE_TYPE.DEFAULT}
          value={value}
        />
      ))}
    </tr>
  )
}

export default Row
